import { forwardRef, useImperativeHandle } from 'react'
import useSlides from '../../hooks/useSlides';
import Slide from '../Slide';
import { motion, AnimatePresence, useAnimate } from "framer-motion";
import useIsTouchDevice from '../../hooks/useIsTouchDevice';
import classes from './Slides.module.scss';
import PropTypes from 'prop-types';

const distance = window.innerWidth;  

const variants = {
  enter: (direction) => {
    return {
      x: direction * distance,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction) => {
    return {
      zIndex: 0,
      x: direction * -distance,
      opacity: 0
    };
  }
};

const swipeConfidenceThreshold = 500;

const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};

const Slides = forwardRef(function Slides(props, ref) {
    const { current, onNavigate, direction, freeze } = props;
  const slides = useSlides();
  const [containerRef, animate] = useAnimate();

  const isTouchDevice = useIsTouchDevice();

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
        await animate(containerRef.current, { opacity: 1, y: 0 }, { duration: .5 })
    },
  }));

  const slide = slides[current];

  return (
    <motion.div ref={containerRef} style={{ opacity: 0, y: 100 }} className={classes.wrapper}>
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
            key={current}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transformTemplate={({ x }) => `translateX(${x})`}
            transition={{
                x: { type: "spring", stiffness: 300, damping: 60, duration: 0.2 },
                opacity: { duration: 0.2 }
            }}
            drag={isTouchDevice ? "x" : false}
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={1}
            onDragEnd={(e, { offset, velocity }) => {
                const swipe = swipePower(offset.x, velocity.x);

                if (swipe < -swipeConfidenceThreshold) {
                  onNavigate(1);
                } else if (swipe > swipeConfidenceThreshold) {
                  onNavigate(-1);
                }
            }}
            >
            <Slide slide={slide} freeze={freeze} />
        </motion.div>
      </AnimatePresence>
    </motion.div>
  )
})

export default Slides

Slides.propTypes = {
    current: PropTypes.number.isRequired,
    onNavigate: PropTypes.func.isRequired,
    direction: PropTypes.number.isRequired,
    freeze: PropTypes.bool.isRequired,
}